import { createPortal } from 'react-dom';
import React, { Fragment, useState, useRef, useEffect } from 'react';
import { withStyles, Grid, Divider } from '@material-ui/core';
import Modal from './Modal';
import Error from '../../asset/img/icon_error.svg';
import RadioBtn from '../../asset/img/icon_radio.svg';
import RadioSelBtn from '../../asset/img/icon_radio_sel.svg';
import { FormControl } from '@material-ui/core';
import { RadioGroup } from '@material-ui/core';
import { FormControlLabel } from '@material-ui/core';
import { Radio } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import Close from '../../asset/img/icon_close.svg';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  drawerFrame: {
    borderRadius: '0',
    borderBottomRightRadius: '0',
    borderBottomLeftRadius: '0',
    height: '100%',
    overflowY: 'auto',
    transform: 'none',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
    position: 'fixed',
    zIndex: '1300',
    inset: '0',
    background: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  dividerTitle: {
    height: '0.0625rem',
    background: '#000',
    margin: '0rem 0.875rem 1.2188rem 0.875rem',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '0.0625rem 0rem',
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '1.5rem',
      height: '1.5rem',
      cursor: 'pointer',
    },
  },
  btnClose: {
    border: 'none',
    background: 'none',
  },
  drawerHeaderClose: {
    position: 'fixed',
    height: '4.375rem',
    background: '#fff',
    width: '100%',
    zIndex: '1',
  },
  closeContainer: {
    display: 'flex',
    minHeight: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ' 0.875rem 1rem',
    marginTop: '1rem',
    placeContent: 'center',
    borderTop: '0.0625rem solid #ddd',
  },
  modalButtonLeft: {
    paddingRight: '4px',
  },
  modalButtonRight: {
    paddingLeft: '4px',
  },
  modalCancel: {
    width: '100%',
    height: '50px',
    borderRadius: '6px',
    border: 'solid 1px #ddd',
    backgroundColor: '#fff',
    fontFamily: 'NotoSansKR',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButton: {
    width: '100%',
    height: '50px',
    borderRadius: '6px',
    fontFamily: 'NotoSansKR',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
  },
  modalConfirm: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0',
  },
  modalConfirmDisable: {
    border: '0',
    backgroundColor: '#999',
    color: '#bbb',
  },

  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0px',
  },
  modalButtonLeft: {
    paddingRight: '0.25rem',
  },
  modalButtonRight: {
    paddingLeft: '0.25rem',
  },
  modalGridContainer: {
    overflowY: 'auto',
    paddingTop: '4.375rem',
  },
  modalGridItemLabel: {
    padding: '5px 14px 0px 14px',
  },
  modalGridItem: {
    padding: '12px 14px',
  },
  modalLabel: {
    // minHeight: "20px",
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',

    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', //"#da0f47"
    },
  },
  disabledButton: {
    color: 'rgba(38, 38, 38, 0.4)',
  },
  modalField: {
    // paddingTop: "12px",
    '& input': {
      borderRadius: '6px',
      width: '100%',
      height: '46px',
      border: 'solid 1px #929292',
      padding: '13px 16px',
    },
  },
  modalPlainBtn: {
    minHeight: '46px',
    borderRadius: '6px',
    border: 'solid 1px #000',
    backgroundColor: '#fff',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalInnerItem: {
    padding: '0px',
    paddingRight: '8px',
  },
  modalInnerItemLast: {
    paddingRight: '0px',
  },
  infoIcon: {
    width: '16px',
    height: '16px',
  },
  textareaField: {
    position: 'relative',
  },
  textarea: {
    width: '100%',
    height: '150px',
    borderRadius: '6px',
    background: '#fff',
    font: 'inherit',
    fontSize: '14px',
    padding: '13px 16px 35px',
  },
  textCount: {
    font: 'inherit',
    fontSize: '12px',
    letterSpacing: 'normal',
    position: 'absolute',
    bottom: '14px',
    right: '16px',
  },
  nextLine: {
    paddingBottom: 0,
  },
  disabled: {
    background: '#ededed',
    border: '0px !important',
  },
  showAll: {
    fontWeight: 'bold',
    fontSize: theme.font.size12,
    letterSpacing: 'normal',
    textDecoration: 'underline',
    // cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: '#000',
  },
  terms: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  termTextArea: {
    height: '120px',
    overflowY: 'auto',
    border: '1px solid #929292',
    borderRadius: '6px 6px 0 0',
    fontSize: theme.font.size12,
    padding: '16px',
    lineHeight: '18px',
  },
  termTextTitle: {
    fontWeight: 'bold',
  },
  checkArea: {
    height: '48px',
    border: '1px solid #929292',
    borderTop: 'none',
    borderRadius: '0 0 6px 6px',
    fontSize: theme.font.size12,
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    '& label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
    },
    '& input': {
      height: '20px',
      width: '20px',
      marginRight: '6px !important',
    },
    '& input.error': {},
  },
  errorIcon: {
    width: '12px',
    height: '12px',
    color: '#ff3723',
    marginRight: '3px',
  },
  errorText: {
    color: '#ff3723',
    fontSize: theme.font.size13,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px',
  },
  // radioLabel:{
  //   fontSize: theme.font.size14,
  // },
  radioGroup: {
    '& .MuiTypography-root': {
      fontSize: theme.font.size14,
    },
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: '#000',
    },
  },
  radio: {
    fontSize: theme.font.size14,
    padding: '10px 0px',
    '& input + label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${RadioBtn}) no-repeat`,
      paddingLeft: '30px',
      padding: '2px 0px 2px 28px',
    },
    // '& input:checked + label': {
    //   width: '100%',
    //   display: 'flex',
    //   alignItems: 'center',
    //   fontSize: theme.font.size14,
    //   fontWeight: 'bold',
    //   background: `url(${RadioSelBtn}) no-repeat`,
    //   paddingLeft: '30px',
    //   padding: '2px 0px 2px 28px',
    // },
    '& input + label[aria-checked="true"]': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${RadioSelBtn}) no-repeat`,
      paddingLeft: '30px',
      padding: '2px 0px 2px 28px',
    },
    '& input': {
      height: '20px',
      width: '20px',
      marginRight: '6px !important',
      display: 'none',
    },
  },
  error: {
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
});

function ReserveCancel(props) {
  const { register } = useForm();

  const { classes, data, modalOpen, modalClose, handleButtonClick } = props;
  const modalRef = useRef();

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  const Input = withStyles(styles)((props) => {
    const { classes, text, placeholder, errorText = placeholder } = props;
    return (
      <Fragment>
        <input type="text" placeholder={placeholder} className={classes.error} />
        <div className={classes.errorText}>
          <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
          {errorText}
        </div>
      </Fragment>
    );
  });

  const handleCancel = () => {
    console.log('cancel clicked');
    handleButtonClick(false, '', data.item, data.button, '취소');
    modalClose();

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }
  };

  const reasons = [
    '서비스 신청 후 제품 정상 가동',
    '시간이 맞지 않거나 다음에 다시 신청',
    '신제품 구매 예정',
    '직접 해결 시도 (수리/이전설치 등)',
    '기타',
  ];

  const [reason, setReason] = useState('');
  const [checked, setChecked] = useState();

  const handleChange = (event) => {
    console.log('event.', event.target.value);
    setReason(event.target.value);
  };

  const handleSubmit = () => {
    console.log('submit clicked', reason);
    handleButtonClick(true, reason, data.item, data.button, '확인');
    modalClose();

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }
  };

  const onClickRadio = (reasonIndex) => {
    setChecked(reasonIndex);
  };
  const activeEnter = (e, reasonIndex) => {
    if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
      onClickRadio(reasonIndex);
    }
  };

  return createPortal(
    <div className={classes.root}>
      {/* <Modal
        component={withStyles(styles)(CancelModal)}
        anchor="bottom"
        title="예약 취소"
        data={data}
        modalOpen={modalOpen}
        modalClose={modalClose}
        customClose={handleCancel}
        height="100%"
        borderRadius="0px"
        closeType="close"
      /> */}
      {modalOpen && (
        <div className={classes.drawerFrame}>
          <div className={classes.drawerRoot}>
            <div className={classes.drawerHeaderClose}>
              <div className={classes.closeContainer}>
                <div className={classes.titleClose} ref={modalRef} tabIndex="0">
                  예약 취소
                </div>
                <div className={classes.close}>
                  <button className={classes.btnClose} onClick={modalClose}>
                    <img src={Close} className={classes.arrowDown} alt="닫기" />
                  </button>
                </div>
              </div>
              <Divider classes={{ root: classes.dividerTitle }} />
            </div>
            <Fragment>
              <Grid container className={classes.modalGridContainer}>
                {/* 사유 */}
                <Grid
                  item
                  xs={12}
                  className={[
                    classes.modalGridItemLabel,
                    classes.modalGridItemLabelFirst,
                  ].join(' ')}
                >
                  <div className={classes.modalLabel}>사유</div>
                </Grid>
                <Grid item xs={12} className={classes.modalGridItem}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label={'출장예약취소'}
                      name="cancelReason"
                      value={reason}
                      onChange={handleChange}
                      className={classes.radioGroup}
                    >
                      {reasons.map((reason, reasonIndex) => (
                        <div className={classes.radio}>
                          <input
                            type="radio"
                            id={`radio${reasonIndex}`}
                            value={reason}
                            name="reasonRadio"
                            onChange={handleChange}
                            className={classes.radio}
                          />
                          <label
                            for={`radio${reasonIndex}`}
                            tabIndex="0"
                            key={reasonIndex}
                            aria-checked={checked === reasonIndex}
                            onClick={() => onClickRadio(reasonIndex)}
                            onKeyDown={(e) => activeEnter(e, reasonIndex)}
                            role="radio"
                            {...register('radioLabel')}
                          >
                            {reason}
                          </label>
                          {/* <FormControlLabel key={`reserve-cancel-${reasonIndex}`} value={reason} control={<Radio />} label={reason} className={classes.radioLabel} /> */}
                        </div>
                      ))}
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
              {/* footer button */}
              <Grid container className={classes.modalFooter}>
                <Grid item xs={6} className={classes.modalButtonLeft}>
                  <button className={classes.modalCancel} onClick={handleCancel}>
                    취소
                  </button>
                </Grid>
                <Grid item xs={6} className={classes.modalButtonRight}>
                  <button
                    disabled={reason === ''}
                    className={[
                      classes.modalButton,
                      reason === '' ? classes.modalConfirmDisable : classes.modalConfirm,
                    ].join(' ')}
                    onClick={handleSubmit}
                  >
                    확인
                  </button>
                </Grid>
              </Grid>
            </Fragment>
          </div>
        </div>
      )}
    </div>,
    document.getElementById('modal')
  );
}
export default withStyles(styles)(ReserveCancel);
